import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 15,
    fontSize: 9,
    lineHeight: 1.2,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
    width: '100%',
  },
  logoSection: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1,
  },
  centerSection: {
    flex: 2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  rightSection: {
    flex: 1,
  },
  logoImage: {
    width: 80,
    height: 80,
    marginRight: 15,
  },
  logoText: {
    flexDirection: 'column',
  },
  centerCompanyName: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#000000',
    textAlign: 'center',
    marginBottom: 4,
  },
  centerIsoText: {
    fontSize: 10,
    color: '#6b7280',
    textAlign: 'center',
  },
  companyHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
    width: '100%',
    position: 'relative',
  },
  logoContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
  },
  companyTextContainer: {
    flex: 1,
    alignItems: 'center',
  },
  companyNameMain: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#000000',
    textAlign: 'center',
    marginBottom: 4,
  },
  companySubtitleMain: {
    fontSize: 14,
    color: '#000000',
    textAlign: 'center',
    marginBottom: 4,
  },
  isoTextMain: {
    fontSize: 10,
    color: '#000000',
    textAlign: 'center',
  },
  companyName: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#000000',
    marginBottom: 4,
    textAlign: 'center',
  },
  companySubtitle: {
    fontSize: 14,
    color: '#6b7280',
    marginBottom: 2,
    textAlign: 'center',
  },
  isoText: {
    fontSize: 10,
    color: '#6b7280',
    textAlign: 'center',
  },
  servicesBar: {
    backgroundColor: '#f3f4f6',
    padding: 8,
    marginBottom: 12,
    textAlign: 'center',
    borderRadius: 4,
  },
  servicesText: {
    fontSize: 9,
    color: '#374151',
    fontWeight: 'bold',
  },
  quotationTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20,
    marginTop: 15,
    color: '#000000',
  },
  quotationDetails: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
  leftDetails: {
    flex: 1,
  },
  rightDetails: {
    flex: 1,
    alignItems: 'flex-end',
  },
  detailRow: {
    marginBottom: 4,
  },
  detailLabel: {
    fontWeight: 'bold',
    color: '#374151',
  },
  clientSection: {
    marginBottom: 15,
  },
  clientName: {
    fontWeight: 'bold',
    marginBottom: 2,
  },
  clientAddress: {
    marginBottom: 2,
  },
  attention: {
    marginBottom: 2,
  },
  subject: {
    marginBottom: 2,
  },
  salutation: {
    marginBottom: 4,
  },
  introductoryText: {
    marginBottom: 8,
    lineHeight: 1.2,
  },
  table: {
    marginBottom: 6,
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f9fafb',
    borderBottomWidth: 1,
    borderBottomColor: '#d1d5db',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },
  tableCell: {
    padding: 4,
    borderRightWidth: 1,
    borderRightColor: '#e5e7eb',
  },
  tableCellCenter: {
    padding: 4,
    borderRightWidth: 1,
    borderRightColor: '#e5e7eb',
    textAlign: 'center',
  },
  tableCellRight: {
    padding: 4,
    borderRightWidth: 1,
    borderRightColor: '#e5e7eb',
    textAlign: 'right',
  },
  srNo: {
    width: '8%',
  },
  description: {
    width: '45%',
  },
  qty: {
    width: '10%',
  },
  uom: {
    width: '10%',
  },
  rate: {
    width: '15%',
  },
  total: {
    width: '12%',
  },
  totalsSection: {
    alignItems: 'flex-end',
    marginBottom: 6,
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '50%',
    marginBottom: 2,
  },
  totalLabel: {
    fontWeight: 'bold',
  },
  grandTotalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '50%',
    backgroundColor: '#e879f9',
    padding: 6,
    borderRadius: 4,
  },
  grandTotalLabel: {
    fontWeight: 'bold',
    fontSize: 10,
  },
  amountInWords: {
    marginBottom: 15,
    fontWeight: 'bold',
    color: '#000000',
  },
  bankDetails: {
    marginBottom: 8,
  },
  bankTitle: {
    fontWeight: 'bold',
    marginBottom: 4,
  },
  bankRow: {
    flexDirection: 'row',
    marginBottom: 2,
  },
  bankLabel: {
    fontWeight: 'bold',
    width: 100,
  },
  termsSection: {
    marginBottom: 8,
  },
  termsTitle: {
    fontWeight: 'bold',
    marginBottom: 4,
  },
  termsList: {
    marginLeft: 8,
  },
  termItem: {
    marginBottom: 2,
  },
  closingStatement: {
    marginBottom: 8,
    lineHeight: 1.2,
  },
  companySignature: {
    marginBottom: 8,
  },
  companyNameSignature: {
    fontWeight: 'bold',
    marginBottom: 2,
  },
  registeredOffice: {
    marginBottom: 2,
  },
  contactNumbers: {
    marginBottom: 2,
  },
  disclaimer: {
    fontSize: 7,
    color: '#6b7280',
    fontStyle: 'italic',
  },
  footer: {
    marginTop: 8,
    paddingTop: 4,
    borderTopWidth: 1,
    borderTopColor: '#e5e7eb',
  },
  footerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 2,
  },
  footerLeft: {
    flex: 1,
  },
  footerRight: {
    flex: 1,
    alignItems: 'flex-end',
  },
  footerBar: {
    backgroundColor: '#f97316',
    padding: 2,
    marginTop: 4,
    textAlign: 'center',
  },
  footerBarText: {
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: 8,
  },
});

interface QuotationItem {
  srNo: number;
  description: string;
  qty: number;
  uom: string;
  rate: number;
  totalAmount: number;
}

interface QuotationData {
  quotationNumber: string;
  date: string;
  clientName: string;
  clientAddress: string;
  attention: string;
  subject: string;
  salutation: string;
  introductoryText: string;
  items: QuotationItem[];
  subTotal: number;
  gstRate: number;
  gstAmount: number;
  grandTotal: number;
  amountInWords: string;
  bankDetails: {
    accountNumber: string;
    ifscCode: string;
    bankName: string;
  };
  termsAndConditions: string[];
  closingStatement: string;
  companyName: string;
  registeredOffice: string;
  contactNumbers: string[];
  email: string;
  website: string;
}

interface QuotationPDFProps {
  quotationData: QuotationData;
}

const QuotationPDF: React.FC<QuotationPDFProps> = ({ quotationData }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* Company Header */}
      <View style={styles.companyHeader}>
        <View style={styles.logoContainer}>
          <Image style={styles.logoImage} src="/AVIS FINAL LOGO png.png" />
        </View>
        <View style={styles.companyTextContainer}>
          <Text style={styles.companyNameMain}>AVI'S ENGINEERING & CONSULTANCY</Text>
          <Text style={styles.companySubtitleMain}>NDT SERVICES</Text>
          <Text style={styles.isoTextMain}>An ISO 9001:2015 Certified Company</Text>
        </View>
      </View>

      {/* Quotation Title */}
      <Text style={styles.quotationTitle}>QUOTATION</Text>

      {/* Quotation Details */}
      <View style={styles.quotationDetails}>
        <View style={styles.leftDetails}>
          <View style={styles.detailRow}>
            <Text style={styles.detailLabel}>Quotation No: </Text>
            <Text>{quotationData.quotationNumber}</Text>
          </View>
          <View style={styles.detailRow}>
            <Text style={styles.detailLabel}>GST NO: </Text>
            <Text>27FLTPM3802F1ZU</Text>
          </View>
        </View>
        <View style={styles.rightDetails}>
          <View style={styles.detailRow}>
            <Text style={styles.detailLabel}>Date: </Text>
            <Text>{quotationData.date}</Text>
          </View>
        </View>
      </View>

      {/* Client Information */}
      <View style={styles.clientSection}>
        <Text style={styles.clientName}>Client Name: {quotationData.clientName}</Text>
        <Text style={styles.clientAddress}>Client Address: {quotationData.clientAddress}</Text>
        <Text style={styles.attention}>Attention: {quotationData.attention}</Text>
        <Text style={styles.subject}>Subject: {quotationData.subject}</Text>
        <Text style={styles.salutation}>{quotationData.salutation}</Text>
        <Text style={styles.introductoryText}>{quotationData.introductoryText}</Text>
      </View>

      {/* Items Table */}
      <View style={styles.table}>
        <View style={styles.tableHeader}>
          <Text style={[styles.tableCell, styles.srNo, { fontWeight: 'bold' }]}>Sr No</Text>
          <Text style={[styles.tableCell, styles.description, { fontWeight: 'bold' }]}>Description</Text>
          <Text style={[styles.tableCellCenter, styles.qty, { fontWeight: 'bold' }]}>Qty</Text>
          <Text style={[styles.tableCellCenter, styles.uom, { fontWeight: 'bold' }]}>UOM</Text>
          <Text style={[styles.tableCellRight, styles.rate, { fontWeight: 'bold' }]}>Rate</Text>
          <Text style={[styles.tableCellRight, styles.total, { fontWeight: 'bold' }]}>Total</Text>
        </View>
        {quotationData.items.map((item, index) => (
          <View key={index} style={styles.tableRow}>
            <Text style={[styles.tableCellCenter, styles.srNo]}>{item.srNo}</Text>
            <Text style={[styles.tableCell, styles.description]}>{item.description}</Text>
            <Text style={[styles.tableCellCenter, styles.qty]}>{item.qty}</Text>
            <Text style={[styles.tableCellCenter, styles.uom]}>{item.uom}</Text>
            <Text style={[styles.tableCellRight, styles.rate]}>{item.rate.toLocaleString()}</Text>
            <Text style={[styles.tableCellRight, styles.total]}>{item.totalAmount.toLocaleString()}</Text>
          </View>
        ))}
      </View>

      {/* Totals */}
      <View style={styles.totalsSection}>
        <View style={styles.totalRow}>
          <Text style={styles.totalLabel}>Sub Total:</Text>
          <Text>{quotationData.subTotal.toLocaleString()}</Text>
        </View>
        <View style={styles.totalRow}>
          <Text style={styles.totalLabel}>GST {quotationData.gstRate}%:</Text>
          <Text>{quotationData.gstAmount.toLocaleString()}</Text>
        </View>
        <View style={styles.grandTotalRow}>
          <Text style={styles.grandTotalLabel}>Grand Total:</Text>
          <Text style={styles.grandTotalLabel}>{quotationData.grandTotal.toLocaleString()}</Text>
        </View>
      </View>

      {/* Amount in Words */}
      <Text style={styles.amountInWords}>
        Amount in Word: {quotationData.amountInWords}
      </Text>

      {/* Bank Details */}
      <View style={styles.bankDetails}>
        <Text style={styles.bankTitle}>Bank Details:</Text>
        <View style={styles.bankRow}>
          <Text style={styles.bankLabel}>Account No:</Text>
          <Text>{quotationData.bankDetails.accountNumber}</Text>
        </View>
        <View style={styles.bankRow}>
          <Text style={styles.bankLabel}>IFSC Code:</Text>
          <Text>{quotationData.bankDetails.ifscCode}</Text>
        </View>
        <View style={styles.bankRow}>
          <Text style={styles.bankLabel}>Bank Name:</Text>
          <Text>{quotationData.bankDetails.bankName}</Text>
        </View>
      </View>

      {/* Terms and Conditions */}
      <View style={styles.termsSection}>
        <Text style={styles.termsTitle}>Terms & Conditions:</Text>
        <View style={styles.termsList}>
          {quotationData.termsAndConditions.map((term, index) => (
            <Text key={index} style={styles.termItem}>
              {index + 1}. {term}
            </Text>
          ))}
        </View>
      </View>

      {/* Closing Statement */}
      <Text style={styles.closingStatement}>{quotationData.closingStatement}</Text>

      {/* Company Signature */}
      <View style={styles.companySignature}>
        <Text style={styles.companyNameSignature}>Faithfully,</Text>
        <Text style={styles.companyNameSignature}>{quotationData.companyName}</Text>
        <Text style={styles.registeredOffice}>Registered Office: {quotationData.registeredOffice}</Text>
        <Text style={styles.contactNumbers}>
          Contact No: {quotationData.contactNumbers.join(', ')}
        </Text>
        <Text style={styles.disclaimer}>This is computer generated, Signature not required.</Text>
      </View>

      {/* Footer */}
      <View style={styles.footer}>
        <View style={styles.footerRow}>
          <View style={styles.footerLeft}>
            <Text>Email: {quotationData.email}</Text>
            <Text>Phone: {quotationData.contactNumbers.join(', ')}</Text>
          </View>
          <View style={styles.footerRight}>
            <Text>Address: {quotationData.registeredOffice}</Text>
          </View>
        </View>
        <View style={styles.footerBar}>
          <Text style={styles.footerBarText}>Website: {quotationData.website}</Text>
        </View>
      </View>
    </Page>
  </Document>
);

export default QuotationPDF;
